function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { T } from "@supersig/validate";
import { cssTypeMap } from "./css";
export const variableTypeNumber = T.object({
    type: T.literal("variable-number"),
    value: T.number
});
export const variableTypeString = T.object({
    type: T.literal("variable-string"),
    value: T.string
});
export const variableTypeBoolean = T.object({
    type: T.literal("variable-boolean"),
    value: T.boolean
});
export const variableTypeMap = {
    "variable-number": variableTypeNumber,
    "variable-string": variableTypeString,
    "variable-boolean": variableTypeBoolean
};
export const variableTypes = T.union("type", variableTypeMap);
export const variableTypeToPrimitiveMapping = {
    "variable-number": "number",
    "varible-string": "string",
    "variable-boolean": "boolean"
};
export const variableValueTypes = T.union("type", _object_spread({}, variableTypeMap, cssTypeMap));
export const variablePrimitiveFromType = (type)=>{
    if (variableTypeMap[type]) {
        return "variable";
    }
    throw new Error(`Unknown type ${type}`);
};
